import CardIcon from '@shared/components/core/card/CardIcon';
import { useTranslation } from 'react-i18next';
import OrgLinks from '../OrgLinks';

export interface ILicenseKeyCardProps {
    orgId: string;
}

export default function LicenseKeyCard({ orgId }: ILicenseKeyCardProps) {
    const { t } = useTranslation();

    if (!orgId) return null;
    return (
        <CardIcon
            name="orgAuthClient"
            title={t('common:license.key.titlePlural')}
            description={t('common:license.key.description')}>
            <OrgLinks organizationId={orgId} variant={'orgLicenseKeys'} />
        </CardIcon>
    );
}
